import { IconButton } from "../IconButton/IconButton";
import { TextInput } from "../TextInput/TextInput";
import { ValidationError } from "../ValidationError/ValidationError";
import { generateTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./CidrRange.module.less";

export type CidrRangeProps = {
	value: string;
	onChange(value: string): void;
	onBlur?(value: string): void;
	validationMessage?: string;
	onRemove(): void;
	trackingId?: string;
};

export const CidrRange = (props: CidrRangeProps): ReactElement => {
	const {
		value,
		onChange,
		onBlur,
		validationMessage,
		onRemove,
		trackingId
	} = props;

	return (
		<>
			<div className={styles.root}>

				<TextInput
					value={value}
					onChange={onChange}
					onBlur={onBlur}
					attachedOn="right"
					isInvalid={Boolean(validationMessage)}
					placeholder={localize("_ExampleIPOrIPRange")}
					trackingId={trackingId}
				/>

				<IconButton
					kind="secondary"
					icon="minus"
					attachedOn="left"
					onClick={onRemove}
					trackingId={generateTrackingId(trackingId, "__remove")}
				/>
			</div>
			<ValidationError
				message={validationMessage}
				trackingId={generateTrackingId(trackingId, "__validation")}
			/>
		</>
	);
};
CidrRange.displayName = "CidrRange";